import { useEffect, useState } from 'react'
import {
  SearchService,
  SearchResultDocument,
  PaginationData,
  SearchAppResponse
} from '@ampcore/client-side-services'

export const useSearchResults = () => {
  const [searchResults, setSearchResults] = useState<SearchResultDocument[]>([])
  const [paginationData, setPaginationData] = useState<PaginationData | null>(
    null
  )
  const [queryTermsRegExp, setQueryTermsRegExp] = useState<string>('')
  const [searchQueryDecoded, setSearchQueryDecoded] = useState<string>('')
  const [searchScrubbed, setSearchScrubbed] = useState<string>('')
  const [suggestedQuery, setSuggestedQuery] = useState<string | undefined>(
    undefined
  )
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  useEffect(() => {
    const searchService = new SearchService()
    const urlParams = new URLSearchParams(window.location.search)
    const queryParam = urlParams.get('sp_q') || ''
    const category = urlParams.get('sp_q_1') || ''
    const spn = parseInt(urlParams.get('sp_n') || '0')
    const scrubbed = decodeURIComponent(urlParams.get('search_scrubbed') || '')
    const decodedQuery = decodeURIComponent(queryParam)

    setSearchQueryDecoded(decodedQuery)
    setSearchScrubbed(scrubbed)

    searchService
      .fetchSearchData(queryParam, category, spn)
      .then((response: SearchAppResponse) => {
        const {
          searchResults,
          paginationData,
          queryTermsRegExp,
          suggestedQuery
        } = response
        setSearchResults(searchResults)
        setPaginationData(paginationData)
        setQueryTermsRegExp(queryTermsRegExp)
        setSuggestedQuery(suggestedQuery)
        setIsLoaded(true)
      })
      .catch(() => {
        setError('Failed to fetch search results.')
        setIsLoaded(true)
      })
  }, [])

  return {
    suggestedQuery,
    searchResults,
    paginationData,
    queryTermsRegExp,
    searchQueryDecoded,
    searchScrubbed,
    isLoaded,
    error
  }
}
